module.exports = __webpack_public_path__ + "static/media/about.163308da.jpeg";